// Chrome Co. — Monochrome motion layer. Adds animation only; never removes content.
(function () {
  var d = document, html = d.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  if (!reduce) html.classList.add('m-js');

  // ---------- Intro curtain (once per browser session) ----------
  function intro() {
    if (reduce || !d.body.classList.contains('template-index')) return;
    var seen = false; try { seen = sessionStorage.getItem('m_intro') === '1'; sessionStorage.setItem('m_intro', '1'); } catch (e) {}
    if (seen) return;
    var el = d.createElement('div'); el.className = 'm-intro'; el.setAttribute('aria-hidden', 'true');
    var w = d.createElement('div'); w.className = 'm-intro-w';
    'CHROME CO.'.split('').forEach(function (c, i) {
      var s = d.createElement('span'); s.textContent = c === ' ' ? '\u00a0' : c; s.style.animationDelay = (i * 0.04) + 's'; w.appendChild(s);
    });
    el.appendChild(w); var bar = d.createElement('div'); bar.className = 'm-intro-bar'; el.appendChild(bar);
    d.body.appendChild(el);
    setTimeout(function () { el.classList.add('out'); }, 1150);
    setTimeout(function () { el.remove(); }, 2200);
  }

  // ---------- Scroll progress + header behaviour ----------
  function chrome() {
    var p = d.createElement('div'); p.className = 'm-progress'; d.body.appendChild(p);
    var hdr = d.querySelector('.site-header'), last = 0, ticking = false;
    function upd() {
      var y = scrollY, max = html.scrollHeight - innerHeight;
      p.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
      if (hdr) {
        hdr.classList.toggle('m-small', y > 40);
        hdr.classList.toggle('m-hide', y > 300 && y > last + 2);
        if (y < last - 2) hdr.classList.remove('m-hide');
      }
      last = y; ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  // ---------- Hero extras ----------
  function hero() {
    var h = d.querySelector('.hero'); if (!h) return;
    var g = d.createElement('div'); g.className = 'm-hero-ghost'; g.setAttribute('aria-hidden', 'true'); g.textContent = 'Chrome'; h.appendChild(g);
    var s = d.createElement('div'); s.className = 'm-scroll'; s.setAttribute('aria-hidden', 'true'); s.innerHTML = '<i></i>Scroll'; h.appendChild(s);
    if (reduce) return;
    var copy = h.querySelector('.hero-copy');
    addEventListener('scroll', function () {
      var y = scrollY, vh = innerHeight; if (y > vh * 1.2) return;
      var k = Math.min(1, y / vh);
      if (copy) { copy.style.transform = 'translateY(' + (y * 0.35) + 'px)'; copy.style.opacity = String(1 - k * 1.1); }
      g.style.transform = 'translateX(' + (-y * 0.4) + 'px)';
    }, { passive: true });
  }

  // ---------- Split headings into masked words ----------
  function split(el) {
    if (el.dataset.mSplit) return; el.dataset.mSplit = '1';
    var words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map(function (w, i) {
      return '<span class="m-line" aria-hidden="true"><span class="m-word" style="--d:' + (i * 0.06) + 's">' + w + '</span></span>';
    }).join(' ');
    el.classList.add('m-split');
  }

  // ---------- Reveal on scroll ----------
  function reveal() {
    if (reduce) return;
    $$('.featured h2, .reviews h2, .contact-strip h2, .page-title').forEach(split);
    var groups = [
      ['.featured > p:first-child, .contact-strip p, .cc-deal-copy > *, .proof-item, .review-card, .site-footer p, .craft-copy p', 'm-rv'],
      ['.ccx-card, .cc-mini, .spot', 'm-rv'],
      ['.pp-gal, .pp-info, .pp-desc .rte > div > *', 'm-rv'],
      ['.field, .contact-strip .btn', 'm-rv']
    ];
    var items = [];
    groups.forEach(function (g) {
      $$(g[0]).forEach(function (el) {
        if (el.closest('.cc-wel')) return;
        el.classList.add(g[1]);
        var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--d', Math.min(sib, 6) * 0.08 + 's');
        items.push(el);
      });
    });
    $$('.ccx-media, .cc-mini-img, .spot-img').forEach(function (m) { m.classList.add('m-dev'); items.push(m); });
    $$('.m-split').forEach(function (el) { items.push(el); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
    // Safety: anything above the fold or missed gets shown after 2.5s
    setTimeout(function () { items.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < innerHeight) el.classList.add('in'); }); }, 2500);
  }

  // ---------- Callout headings light up word by word ----------
  function callouts() {
    var hs = $$('.craft-step h2'); if (!hs.length) return;
    hs.forEach(function (h) {
      var t = h.textContent.trim(); h.setAttribute('aria-label', t);
      h.innerHTML = t.split(/\s+/).map(function (w) { return '<span class="m-fw" aria-hidden="true">' + w + '</span>'; }).join(' ');
    });
    if (reduce) { $$('.m-fw').forEach(function (w) { w.classList.add('lit'); }); return; }
    function upd() {
      hs.forEach(function (h) {
        var r = h.getBoundingClientRect(), ws = h.querySelectorAll('.m-fw');
        var p = 1 - (r.top - innerHeight * 0.25) / (innerHeight * 0.5);
        var n = Math.round(Math.max(0, Math.min(1, p)) * ws.length);
        for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('lit', i < n);
      });
    }
    addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); upd();
  }

  // ---------- Marquee: speeds up and skews with scroll velocity ----------
  function marquee() {
    $$('.marquee-track').forEach(function (tr) {
      if (reduce) return;
      var x = 0, v = 0, lastY = scrollY, half = 0;
      function measure() { half = tr.scrollWidth / 2; }
      measure(); addEventListener('resize', measure);
      (function loop() {
        var dy = scrollY - lastY; lastY = scrollY;
        v += (Math.abs(dy) * 0.15 - v) * 0.1;
        x -= 0.6 + v;
        if (half && -x >= half) x += half;
        tr.style.transform = 'translate3d(' + x + 'px,0,0) skewX(' + (-Math.min(v, 12)) + 'deg)';
        requestAnimationFrame(loop);
      })();
    });
  }

  // ---------- Countdown digits flip on change ----------
  function countdown() {
    if (reduce) return;
    $$('[data-cc-cd]').forEach(function (b) {
      var prev = b.textContent;
      new MutationObserver(function () {
        if (b.textContent === prev) return; prev = b.textContent;
        b.classList.remove('m-tick'); void b.offsetWidth; b.classList.add('m-tick');
      }).observe(b, { childList: true, characterData: true, subtree: true });
    });
  }

  // ---------- Cursor ring + magnetic buttons (desktop only) ----------
  function cursor() {
    if (!fine || reduce) return;
    var ring = d.createElement('div'), dot = d.createElement('div');
    ring.className = 'm-cursor'; dot.className = 'm-dot';
    ring.setAttribute('aria-hidden', 'true'); dot.setAttribute('aria-hidden', 'true');
    d.body.appendChild(ring); d.body.appendChild(dot);
    var mx = -100, my = -100, rx = -100, ry = -100;
    addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY; ring.classList.add('on'); dot.classList.add('on');
      dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';
      var t = e.target.closest && e.target.closest('.ccx-card, .cc-mini, .spot, .mh-img');
      ring.classList.toggle('big', !!t);
    });
    d.addEventListener('mouseleave', function () { ring.classList.remove('on'); dot.classList.remove('on'); });
    (function loop() { rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18; ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0)'; requestAnimationFrame(loop); })();

    $$('.btn, .cc-btn, .pp-info .pp-add, .spot-btn').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect(), x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        b.style.translate = (x * 0.18) + 'px ' + (y * 0.3) + 'px';
      });
      b.addEventListener('mouseleave', function () { b.style.translate = '0 0'; });
      b.style.transition += ', translate .4s cubic-bezier(.16,1,.3,1)';
    });
  }

  function start() { intro(); chrome(); hero(); reveal(); callouts(); marquee(); countdown(); cursor(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
